import { c as _c } from "react/compiler-runtime";
import { ValuesSchemaType } from "../../schemas";
import { Checkbox } from "@/components/ui/checkbox";
type Props = {
  activeValues: ValuesSchemaType;
  inactiveValues: ValuesSchemaType;
  onChange: (value: string | number | boolean) => void;
};
export function MobileFilterCheckboxList(t0) {
  const $ = _c(15);
  const {
    activeValues,
    inactiveValues,
    onChange
  } = t0;
  const hasActiveValues = activeValues.length > 0;
  const hasInactiveValues = inactiveValues.length > 0;
  let t1;
  if ($[0] !== activeValues || $[1] !== hasActiveValues || $[2] !== onChange) {
    t1 = hasActiveValues && activeValues.map(value => <div key={value.value.toString()} onClick={() => onChange(value.value)} className="flex items-center gap-3 min-h-[48px] px-4 capitalize cursor-pointer active:bg-zinc-100"><Checkbox checked={true} size="sm" className="pointer-events-none" />{value.decorator ?? <span className="text-sm text-zinc-800">{value.label}</span>}</div>);
    $[0] = activeValues;
    $[1] = hasActiveValues;
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== hasActiveValues || $[5] !== hasInactiveValues) {
    t2 = hasActiveValues && hasInactiveValues && <div className="border-b mx-4" />;
    $[4] = hasActiveValues;
    $[5] = hasInactiveValues;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== hasInactiveValues || $[8] !== inactiveValues || $[9] !== onChange) {
    t3 = hasInactiveValues && inactiveValues.map(value_0 => <div key={value_0.value.toString()} onClick={() => onChange(value_0.value)} className="flex items-center gap-3 min-h-[48px] px-4 capitalize cursor-pointer active:bg-zinc-100"><Checkbox size="sm" className="pointer-events-none" />{value_0.decorator ?? <span className="text-sm text-zinc-800">{value_0.label}</span>}</div>);
    $[7] = hasInactiveValues;
    $[8] = inactiveValues;
    $[9] = onChange;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <div data-sentry-component="MobileFilterCheckboxList" data-sentry-source-file="MobileFilterCheckboxList.tsx">{t1}{t2}{t3}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}